const _route = {
    // Public
    _landing: '/',

    // Auth
    _login: '/login',
    _signup: '/signup',
    _verify: '/verify',
    _forgot_password: '/forgot-password',
    _reset_password: '/reset-password',

    // Participant
    _dashboard: '/dashboard',
    _team: '/team',
    _team_create: '/team/create',
    _submission_new: '/submission/new',
    _submission_view: '/submission/:id',
    _submission_agreement: '/submission/:id/agreement',
    _submission_video: '/submission/:id/video',
    _video_pitch: '/video-pitch',
    _fundraising: '/fundraising',
    _implementation: '/implementation',

    // Judge
    _judge_dashboard: '/judge/dashboard',
    _judge_submission: '/judge/submissions/:id',
    _judge_score: '/judge/submissions/:id/score',
    _judge_video: '/judge/submissions/:id/video',
    _judge_calibration: '/judge/calibration',

    // Admin
    _admin_dashboard: '/admin/dashboard',
    _admin_competition: '/admin/competition',
    _admin_submissions: '/admin/submissions',
    _admin_submission_detail: '/admin/submissions/:id',
    _admin_teams: '/admin/teams',
    _admin_team_detail: '/admin/teams/:id',
    _admin_judges: '/admin/judges',
    _admin_fundraising: '/admin/fundraising',
    _admin_implementation: '/admin/implementation',
    _admin_notifications: '/admin/notifications',
    _admin_legal: '/admin/legal',
    _admin_users: '/admin/users',

    // Shared
    _notifications: '/notifications',
    _profile: '/profile',

    // Error
    _errorpage: '*'
}

export default _route
